import { faEdit, faMicrophone } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { Badge, Card, Col, Row, Stack } from "react-bootstrap";
import { Note } from "../../../../types/note";
import IconButton from "../../../ui/IconButton";

interface CustomViewState {
  n: Note;
  setEdit: any;
  setCurrent: any;
  type: any;
}

const CustomNoteView = ({ n, setEdit, setCurrent, type }: CustomViewState) => {
  const onClickEdit = () => {
    setEdit(true);
    setCurrent(n);
  };

  const dateField = Array.isArray(n?.fields) ? n.fields.find((f: any) => f.key === "date")?.value : n?.fields?.date;

  return (
    <Card className="bg-light mb-3 cursor-pointer" onClick={(e) => onClickEdit()}>
      <Card.Body>
        <>
          <Row>
            <Col>
              <h5 className="app-orange-text">{n.notetypename}</h5>
            </Col>
            <Col className="text-end">
              <label className="note-type text-muted me-3">{dateField}</label>
              <IconButton onClickButton={onClickEdit} tooltipText="Edit Note" icon={faEdit} />
            </Col>
          </Row>
          {(type?.fields || [])
            .filter((field: any) => field.preview)
            .sort((a: any, b: any) => {
              if (a.type === "multi-line text" && b.type !== "multi-line text") return 1;
              if (a.type !== "multi-line text" && b.type === "multi-line text") return -1;
              return 0;
            })
            .map((field: any) => {
              const value = Array.isArray(n?.fields) ? n.fields.find((f: any) => f.key === field.key)?.value : n?.fields?.[field.key];

              return (
                <>
                  {field.type === "multi-line text" ? (
                    <Row>
                      <div
                        id="capture-text"
                        style={{
                          height: "80px",
                          pointerEvents: "none",
                          backgroundColor: "#e9ecef",
                          color: "#6c757d",
                          whiteSpace: "pre-wrap",
                          wordWrap: "break-word",
                          overflow: "hidden",
                          border: "1px solid #ccc",
                          padding: "5px",
                        }}
                      >
                        {value ?? ""}
                      </div>
                    </Row>
                  ) : (
                    <Row>
                      <h6 className="fw-normal">{value ? `${field.label} - ${value}` : ""}</h6>
                    </Row>
                  )}
                </>
              );
            })}
          <Row className="mt-2">
            <Col className="col-6 text-start">
              <Stack direction="horizontal" gap={3}>
                <Badge bg="secondary">
                  Created By {n.firstname} {n.lastname}
                </Badge>
                {n?.recordingsExist === true && <IconButton tooltipText="Recordings Exist" icon={faMicrophone} />}
              </Stack>
            </Col>
            <Col className="col-6 text-end">
              {n.subject?.room && (
                <Badge bg="secondary" className="me-2">
                  {n.subject?.room + " " + n.subject?.bed}
                </Badge>
              )}
              <Badge bg="secondary">{n.subject?.name}</Badge>
            </Col>
          </Row>
        </>
      </Card.Body>
    </Card>
  );
};

export default CustomNoteView;
